import React from "react";

const hashString = (str: string) =>
  str.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);

const getConsistentColor = (name: string) => {
  const colors = [
    "#FF5733",
    "#33FF57",
    "#3357FF",
    "#FF33A6",
    "#FFD133",
    "#8E44AD",
    "#1ABC9C",
    "#E67E22",
    "#2ECC71",
    "#3498DB",
  ];
  return colors[hashString(name) % colors.length];
};

const getInitial = (name: string) => name.charAt(0).toUpperCase();

const RoundedProfilePicture = ({
  name,
  url,
  size = 44,
}: {
  name: string;
  url?: string;
  size?: number;
}) => {
  const fontSize = size / 2.5;

  if (url) {
    return (
      <img
        className="rounded-full"
        src={url}
        alt={name}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div
      className="rounded-full flex justify-center items-center text-white font-bold"
      style={{
        width: size,
        height: size,
        backgroundColor: getConsistentColor(name),
        fontSize,
      }}
    >
      {getInitial(name)}
    </div>
  );
};

export default RoundedProfilePicture;
